import { UniRoColumn } from "./Bit/UniRoColumn";
import { Ip2locationSchema } from "./ConfigSchema/Ip2locationSchema";

export const PluginsMap: any = {
    'bit-UniRoColumn': UniRoColumn,

    config: {
        ip2location: Ip2locationSchema,
    }
}